import TeamScore from './TeamScore.vue';
export default TeamScore;
